import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'

export const TtsDeleteButtonWrapper = styled.div<{
  $isDisabled: boolean
}>`
  padding: 2px;
  border-radius: 4px;
  background: none;
  cursor: pointer;

  ${({ $isDisabled }) =>
    $isDisabled
      ? css`
          opacity: 0;
          pointer-events: none;
        `
      : css`
          &:hover {
            background-color: ${COLORS.primarySemiLight};
          }
        `}
`
